export default {
  id: 224,
  title: 'Target #224 - Levelled',
  url: 'https://cssbattle.dev/play/224',
  colors: ['#F8B140', '#000000', '#FFFFFF', '#67AED4'],
  solution:
    '<p a><p b><style>p[a],p[b]{left:125;border-radius:1in}body{background:#f8b140}p{position:fixed;margin:0}p[a]{bottom:75;width:150;height:150;background:linear-gradient(#fff 75px,#67aed4 75px);box-shadow:0 0 0 15px #fff,0 0 0 45px #000}p[b]{top:125;width:50;height:50;background:#67aed4;box-shadow:50px 0 #fff,100px 0 #67aed4}',
}
